var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUsdt = function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#50AF95"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "usdt_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#50AF95",
    stroke: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#usdt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.22 13.2c-.067.006-.42.029-1.206.029-.624 0-1.068-.02-1.224-.028-2.415-.116-4.218-.572-4.218-1.119 0-.546 1.803-1.002 4.218-1.12v1.784c.158.012.61.041 1.235.041.75 0 1.126-.034 1.194-.04v-1.783c2.41.116 4.209.573 4.209 1.118 0 .546-1.799 1.002-4.21 1.118h.003Zm0-2.42V9.183h3.365V6.75H7.426v2.434h3.363v1.595C8.056 10.915 6 11.503 6 12.207c0 .705 2.056 1.292 4.79 1.43v5.113h2.43v-5.116c2.728-.136 4.78-.723 4.78-1.427 0-.704-2.05-1.291-4.78-1.428Z",
    fill: "#fff"
  }))));
};
export default SvgUsdt;